import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import TitleText from '../common/TitleText';
import 'react-slideshow-image/dist/styles.css';
import MethodsExample from './MethodsExample';
import ReviewItem from './ReviewItem';
import axiosInstance, { API_URL } from '../common/Constants';

const styles = (theme) => ({
  bg: {
    backgroundColor: '#fafafa',
    paddingBottom: '50px',

    width: '100%',
  },
  reviewOuter: {
    width: '80%',
    minWidth: '940px',
  },
  webVer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobVer: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  itemOuter: {
    width: '380px',
    [theme.breakpoints.down('lg')]: {
      width: '340px',
    },
    [theme.breakpoints.down('md')]: {
      width: '300px',
    },
  },
});
/*
const reviewData = [
  {
    id: '1',
    name: '주단태',
    profilePic: '/images/main_bg.png',
    reviewDate: '2021-01-11',
    reviewPic: '/images/main_bg.png',
    reviewTxt:
      '로봇을 닮은 생김새가 재미있는 등대.두 개의 등대 모두 머리 부분이 특이하게 로봇 모양을 하고 있기도 해마징가Z, 태권V 등대로 불리기도 합니다. 장승등대는 육지와 떨어진 해상 방파제에 있어 직접 가까이에서 보기엔 어렵고 배를 타고 나가거나 멀리서나마 볼 수 밖에 없으니 참고하세요! ^^',
  },
  {
    id: '2',
    name: '김땡땡',
    profilePic: '/images/sample.png',
    reviewDate: '2021-11-11',
    reviewPic: '/images/sample.png',
    reviewTxt:
      '호남의 금강산이라 불리는 대둔산의 설경 또한 장관입니다! 높이는 878m인 대둔산은 칠성봉, 장군봉 등 암봉이 6km에 걸쳐 이어져 수려한 산세를 이루고 삼선 바위, 용문골 등 사방으로 기암괴석이 한데 어우러져 있습니다. 대둔은 ‘인적이 드문 벽산 두메산골의 험준하고 큰 산봉우리’란 뜻을 가지고 있어요~',
  },
  {
    id: '3',
    name: '이땡땡',
    profilePic: '/images/main_bg.png',
    reviewDate: '2019-01-11',
    reviewPic: '/images/main_bg.png',
    reviewTxt:
      '통영생태숲은 숲의 둘레를 따라 난 둘레길을 따라 걸을 수 있는 순환형 산책로로 되어 있다. 숲길을 걷다 보면 중간중간 표고버섯이나 유자, 매실재배 등의 체험을 직접 해볼 수 있는 체험형 쉼터도 마련되어 있고 숲에서 나는 향이 좋기로 유명한 편백나무 숲길을 따라 걸을 수 있는 산책로도 만날 수 있다.',
  },
];
*/

class BestReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
      matches: window.matchMedia('(max-width:960px)').matches,
      reviewData: [],
    };
  }

  getReview = () => {
    axiosInstance.get(`${API_URL}/review/best`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      this.setState({ reviewData: response.data });
    });
  };

  componentDidMount() {
    this.getReview();
  }

  onClickReview = (data) => {
    this.props.onClickReview(data);
  };

  callBackClickItem = (data) => {
    this.props.onClickReview(data);
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.bg}>
        <Grid container justify="center">
          <TitleText title="BEST REVIEW" />
        </Grid>

        {/* 웹 버전 */}
        <Grid container justify="center" className={classes.webVer}>
          <Grid container className={classes.reviewOuter} justify="space-between">
            {this.state.reviewData &&
              this.state.reviewData.map((data, index) => {
                return index < 3 ? (
                  <div
                    className={classes.itemOuter}
                    key={`bestreview-div-${index}`}
                    onClick={() => {
                      this.onClickReview(data);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <ReviewItem key={`bestreview-item-${index}`} data={data} />
                  </div>
                ) : null;
              })}
          </Grid>
        </Grid>
        {/* 모바일버전 */}
        <div className={classes.mobVer}>
          <MethodsExample reviewData={this.state.reviewData} callBackClickItem={this.callBackClickItem} />
        </div>
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(BestReview));
